import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    actionPlanTaskItemWrapper: {
        display: "flex",
        padding: theme.spacing(3),
        justifyContent: "space-between",
        alignItems: "center",
    },
    leftContent: {
        display: "flex",
        gap: theme.spacing(2),
        alignItems: "center",
    },
}));
